import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const ProductsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 4px;
`

export const CountWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Count = styled.p`
  line-height: 1.5;
`

export const SelectedProductsContainer = styled.div<{ isEditable: boolean }>`
  ${mediaQueries.laptop} {
    margin-top: ${({ isEditable }) => (isEditable ? '8px -46px 0' : '8px -30px 0')};
  }
`
export const ExplanationText = styled.p`
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  color: var(--text-secondary);

  margin-top: var(--space-200);
`
